let blockedByDialog: HTMLDialogElement | null = null;

export const dialogQueue = {
  block(dialog: HTMLDialogElement): void {
    blockedByDialog = dialog;
  },

  unblock(): void {
    blockedByDialog = null;
  },

  closeBlocker(): void {
    if (blockedByDialog) {
      blockedByDialog.close();
      blockedByDialog = null;
    }
  },

  isBlocked(): boolean {
    return blockedByDialog !== null;
  },
};
